import { useSearchParams } from 'react-router-dom';

export const useGetStudentDataParams = () => {
  const [searchParams] = useSearchParams();
  const assignmentId = searchParams.get('assignmentId');
  const teacherClassId = parseInt(searchParams.get('classId') ?? '', 10) || 0;

  return { assignmentId, teacherClassId };
};
